import { graphql } from '~/lib/graphql'

export const GetReservableCalendarAndMealPeriod = graphql(`
  query getReservableCalendarAndMealPeriod(
    $restaurantId: RestaurantId!
    $input: ReservableCalendarInput!
    $searchInput: SearchInput!
  ) {
    restaurant(restaurantId: $restaurantId) {
      reservableCalendar(input: $input) {
        ...ReservableCalendarItem
      }
      searchCourses(input: $searchInput) {
        nodes {
          searchPlans(input: $searchInput) {
            nodes {
              mealPeriod
            }
          }
        }
      }
    }
  }
`)
